<template>
    <div>
      <el-dialog title="单个发放" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
                 :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog"  width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
               @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
  
        <!-- 品牌信息 -->
        <div class="detail-wrap">
          <div class="d-cont edit-mce-box">
            <div class="d-item">
              <div class="title first">
                <b>发放工程师</b>
              </div>
              <table class="table-detail">
                <tbody>
                <tr>
                  <th>
                    工程师工号
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.barcode" style="width: 165px;" clearable/>
                  </td>
                  <th>
                    工程师手机
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.barcode" style="width: 165px;" clearable/>
                  </td>
                </tr>
                <div style="height: 5px;"></div>
                </tbody>
              </table>
            </div>
  

          </div>
        </div>
        <span slot="footer" class="dialog-footer">
                <span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
                <el-button type="primary" plain class="button-sty" @click="dialogClose">
                    <i class="el-icon-close el-icon"></i>
                    取 消
                </el-button>
                <el-button type="primary" @click="commitData" class="button-sty">
                    <i class="el-icon-check el-icon"></i>
                    确 定
                </el-button>
            </span>
      </el-dialog>
      <!-- 产品 -->
      <preconditionDialog v-if="showItemDialog" @commitSelectedRow="commitSelectedRow2"
                          :visiable.sync="showItemDialog" :multi="true" :brandId="formData.brandId"/>
  
      <orderDialog v-if="showOrderDialog" :visiable.sync="showOrderDialog" :multi="true" @commit="confirmSite"/>
    </div>
  </template>
  
  <script>
  import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
  import {initVxeTable} from '@/const/crud/admin/table';
  
  import {fetchTree} from "@/api/admin/type_tree";
  import pager from '@/components/pager/index.vue';
  import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
  import orderDialog from '@/views/dialogCommon/radioOrderDialog.vue';
  import store from "@/store";
  import api from "@/api/projectApi";
  import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
  
  export default {
    name: 'saleConfigDialog',
    props: ['visiable', 'multi', 'param', 'obj'],
    mixins: [selectDialogMixins],
    components: {preconditionDialog, pager, orderDialog},
  
    created() {
      this.initSetting()
      if (this.obj) {
        this.formData = this.obj
        this.fileFormat()
        console.log(this.formData)
      }
      // if (this.obj.id == '') {
      //   this.notCreate = false
      // }
      // if (this.obj.id == 0) {
      //   this.formData = this.obj
      //   this.fileFormat()
      // } else if (this.obj.id != null) {
      //   this.$http({
      //     url: api.basCustAsset.getDataUrl,
      //     method: 'post',
      //     data: {
      //       id: this.obj.id
      //     }
      //   }).then(res => {
      //     this.formData = res.data.data
      //     this.fileFormat()
      //   })
      // }
      // this.formData.profileId = this.obj.profileId
  
    },
  
    watch: {
      'formData.brandId': {
        handler(newVal, oldVal) {
          this.brandOptions.forEach(item => {
            if (item.value === newVal) {
              this.formData.brandName = item.label
            }
          })
          // this.formData.brandId = newVal.value
          // this.formData.brandName = newVal.label
        },
        immediate: true,
        deep: true
      },
    //   picList1: {
    //     handler(newVal, oldVal) {
    //       this.formData.pic1 = uploadFileFormat(newVal)
    //     },
    //     immediate: true,
    //     deep: true
    //   },
    //   picList2: {
    //     handler(newVal, oldVal) {
    //       this.formData.pic2 = uploadFileFormat(newVal)
    //     },
    //     immediate: true,
    //     deep: true
    //   },
    //   picList3: {
    //     handler(newVal, oldVal) {
    //       this.formData.pic3 = uploadFileFormat(newVal)
    //     },
    //     immediate: true,
    //     deep: true
    //   },
    //   fileList: {
    //     handler(newVal, oldVal) {
    //       this.formData.eleRepariUrl = uploadFileFormat(newVal)
    //     },
    //     immediate: true,
    //     deep: true
    //   }
    },
  
    mounted() {
      this.loadBrandOption()
      this.loadBuyChannelOption()
  
      this.loadProductOption0()
      this.loadProductOption1()
    },
  
    computed: {
      api() {
        return api
      },
      pdfUrl() {
        if (this.formData.contractFile != null && this.formData.contractFile.length !== 0) {
          return this.formData.contractFile[0].url
        }
        return ''
      },
      itemCategory() {
        return this.formData.bigCategoryName + " " + this.formData.smallCategoryName
      },
      headers: function () {
        const tenantId = store.getters.userInfo.tenantId
        return {
          'Authorization': "Bearer " + store.getters.access_token,
          'TENANT-ID': tenantId ? tenantId : '1'
        };
      }
    },
  
    data() {
      return {
        showItemDialog: false,
        // getBrandListUrl: '/basic/snCompanyBrand/getBrandList',
        // getBuyChannelListUrl: '/basic/basBuyChannel/getList',
        // updateDataUrl: '/basic/basCustAsset/update',
        // addDataUrl: '/basic/basCustAsset/add',
        // brandOptions: [],
        // buyChannelOptions: [],
        // productOptions0: [],
        // productOptions1: [],
        // upload_btn1: true,
        // upload_btn2: true,
        // upload_btn3: true,
        // upload_btn4: true,
        // upload_btn5: true,
        // upload_btn6: true,
  
        showPreconditionDialog2: false,
        total: 0,
        filterText: '',
        data: [],
        notCreate: true,
  
        pageSizes: [10, 20, 100],
        //以上树形
        activeName: 'second',
        dataId: 0,
        showEdit: false,
        vxeOption: {},
        isRouterAlive: true,
        // 查询参数
        formData: {
          isNew: true,
  
          orderId: null,
          orderNo: null,
          profileId: '',
          id: null,
          brand: {value: '', label: ''},
          barcode: '',
          buyPrice: '',
          stat: 1,
          brandId: null,
          brandName: "",
          itemId: '',
          itemCode: "",
          itemName: "",
          bigCategoryId: '',
          bigCategoryName: '',
          smallCategoryId: '',
          smallCategoryName: '',
          extendPeriodMonth: 0,
          standPeriodMonth: 0,
          careDate: '',
          fixDate: '',
          buyDate: '',
          pic1: null,
          pic2: null,
          pic3: null,
          eleRepariUrl: null,
  
          activeStat: 0,
          repairCardNo: '',
          contractFile: [],
        },
        showOrderDialog: false,
        showDialog: true,
        falseValue: false,
        selectMulti: true,
        picList1: [],
        picList2: [],
        picList3: [],
        picList4: [],
        picList5: [],
        picList6: [],
        fileList: [],
  
      };
    },
  
  
    methods: {
          // 加载产品大类
          loadProductOption0() {
        fetchTree({
          categoryType: 1,  // 产品
          // usable: 1  // 加载启用的
        }).then(response => {
          this.productOptions0 = []
          console.log(response.data.data,"大类的选项");
          response.data.data.forEach(item => {
  
            this.productOptions0.push({
              label: item.categoryName,
              value: item.id
            })
          })
        });
      },
  
      // 加载产品小类
      loadProductOption1() {
        if (this.formData.bigCategoryId === ''
          || this.formData.bigCategoryId === null
          || this.formData.bigCategoryId === undefined) {
          this.productOptions1 = []
        } else {
          fetchTree({
            categoryType: 1,  // 产品
            // usable: 1,  // 加载启用的
            parentId: this.formData.bigCategoryId
          }).then(response => {
            this.productOptions1 = []
            response.data.data.forEach(item => {
              this.productOptions1.push({
                label: item.categoryName,
                value: item.id
              })
            })
          })
        }
      },
          // 产品大类选中加载小类
          productSelectOne(value) {
  console.log(value.name,"选择的大类");
        this.productOptions1 = []
        this.formData.smallCategoryId = null
        this.loadProductOption1()
      },
      confirmSite(row) {
        console.log(row, '弹窗数据')
        this.formData.orderNo = row.orderNo
        if (row.id) {
          this.formData.orderId = row.id
        }
        if (row.orderId) {
          this.formData.orderId = row.orderId
        }
      },
  
  
      fileFormat() {
        this.picList1 = echoFileFormat(this.formData.pic1)
        this.picList2 = echoFileFormat(this.formData.pic2)
        this.picList3 = echoFileFormat(this.formData.pic3)
        this.fileList = echoFileFormat(this.formData.eleRepariUrl)
      },
  
      commitSelectedRow2(data) {
        console.log(data,"data产品大类");
        this.formData.itemId = data.id
        this.formData.itemName = data.itemName
        this.formData.itemCode = data.itemCode
        // this.formData.bigCategoryId = data.bigCategoryId
        // this.formData.bigCategoryName = data.bigCategoryName
        // this.formData.smallCategoryId = data.smallCategoryId
        // this.formData.smallCategoryName = data.smallCategoryName
        console.log(this.formData)
      },
  
      showItemDialogFunc() {
        console.log(this.formData.brandId, 'brand')
        if (this.formData.brandId !== '' && this.formData.brandId !== null) {
          this.showItemDialog = true
        } else {
          this.$message.warning('请先选中品牌')
        }
      },
  
      // 当前页面确认按钮逻辑
      commitData() {
        if (this.formData.barcode === '') {
         return this.$message.warning('机器条码不能为空')
        }
   
        // if (this.formData.profileId !== '') {  // 有profileId,为修改用户状态，调用接口操作，接口返回成功传数据给父元素
        //   this.$http({
        //     url: this.formData.id === '' ? this.addDataUrl : this.updateDataUrl,
        //     method: 'post',
        //     data: this.formData
        //   }).then(res => {
        //     this.$message.success(this.formData.id === '' ? '添加成功' : '修改成功')
        //
        //     this.$emit('commitData', this.formData, true)
        //     this.dialogClose()
        //   })
        // } else {
        if (!this.formData.id) {
          this.formData.id = - new Date().getTime()
        }
        //   // if (this.formData.contractFile !== undefined && this.formData.contractFile.length !== 0) {
        //   //   this.formData.eleRepariUrl = this.formData.contractFile[0].url
        //   // } else {
        //   //   this.formData.eleRepariUrl = ''
        //   // }
          this.$emit('commitData', this.formData)
          this.dialogClose()
        // }
      },
  
      pdfHandleSuccess(res, file, fileList) {
        // 上传成功后，隐藏上传按钮
        this.upload_btn = true;
        this.fileList = [
          {url: res.data.url}
        ]
      },
      pdfHandleRemove() {
        this.fileList = []
      },
      handleRemove1(response, file, fileList) {
        this.picList1 = []
      },
      handleRemove2(response, file, fileList) {
        this.picList2 = []
      },
      handleRemove3(response, file, fileList) {
        this.picList3 = []
      },
      handleRemove4(response, file, fileList) {
        this.picList4 = []
      },    handleRemove3(response, file, fileList) {
        this.picList5 = []
      },    handleRemove3(response, file, fileList) {
        this.picList5 = []
      },    handleRemove6(response, file, fileList) {
        this.picList6 = []
      },
      handleSuccess1(res, file, fileList) {
        this.upload_btn1 = false;
        console.log(res.data.url, "url")
        this.picList1 = [
          {url: res.data.url}
        ]
      },
      handleSuccess2(res, file, fileList) {
        this.upload_btn2 = true;
        console.log(res.data.url, "url")
        this.picList2 = [
          {url: res.data.url}
        ]
      },
      handleSuccess3(res, file, fileList) {
        this.upload_btn3 = true;
        console.log(res.data.url, "url")
        this.picList3 = [
          {url: res.data.url}
        ]
      },
      handleSuccess4(res, file, fileList) {
        this.upload_btn4 = true;
        console.log(res.data.url, "url")
        this.picList4 = [
          {url: res.data.url}
        ]
      },   
       handleSuccess5(res, file, fileList) {
        this.upload_btn5 = true;
        console.log(res.data.url, "url")
        this.picList5 = [
          {url: res.data.url}
        ]
      },    handleSuccess6(res, file, fileList) {
        this.upload_btn6 = true;
        console.log(res.data.url, "url")
        this.picList6 = [
          {url: res.data.url}
        ]
      },
  
      // 加载品牌
      loadBrandOption() {
        this.$http({
          url: this.getBrandListUrl,
          method: 'post',
          data: {
            usable: 1  // 加载启用的
          }
        }).then(res => {
          this.brandOptions = []
          res.data.data.forEach(item => {
            this.brandOptions.push({
              label: item.brandName,
              value: item.id
            })
          })
        })
      },
      // 加载购买渠道
      loadBuyChannelOption() {
        this.$http({
          url: this.getBuyChannelListUrl,
          method: 'post',
          data: {
            buyChannelName: null
          }
        }).then(res => {
          this.buyChannelOptions = []
          res.data.data.forEach(item => {
            this.buyChannelOptions.push({
              label: item.buyChannelName,
              value: item.id
            })
          })
        })
      },
  
  
    }
  };
  </script>
  <style lang="scss" scoped>
  .papers {
    position: absolute;
    left: 292px;
    top: 0px;
  
    ::v-deep.el-upload-list .el-upload-list__item {
      display: inline-block;
      width: 147px !important;
      margin-right: 14px;
      border-radius: 2px;
      border-color: #e8e8e8;
      margin-top: 7px;
      margin-left: 15px;
      padding: 0px !important;
      background-color: #e1e1e1;
      height: 20px;
    }
  
  }
  
  // ::v-deep .el-dialog {
  //     margin-top: 110px !important;
  //     overflow: hidden;
  // }
  
  
  .d-item {
    border: 1px solid #ededed;
  }
  
  .table-detail {
    padding-left: 35px;
    display: inline-block;
  }
  
  .table-detail tr {
    margin-bottom: 10px;
    display: inline-block;
  
    th {
      font-weight: 400;
      text-align: right;
      width: 112px;
      font-size: 12px;
      position: relative;
      padding: 0 10px 0 4px;
      color: rgba(86, 86, 86, 0.96);
  
    }
  
    // td{
    // 	display: inline-block;
    // 	width: 170px !important;
    // }
  }
  .title b {
    display: inline-block;
    line-height: 28px;
    font-size: 16px;
    font-weight: 600;
    margin-right: 84px;
    vertical-align: middle;
    color: #2a6494;
    position: relative;
    z-index: 2;
    background: rgba(42, 100, 148, 0.16);
    margin-left: 0px;
    margin-top: 8px;
    padding-left: 12px;
    padding-right: 14px;
    border-radius: 0 28px 28px 0;
  }
  
  .detail-wrap {
    background-color: #fff;
    padding: 5px;
  }
  
  // 单选框的样式
  ::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
    top: -1px;
  }
  
  ::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
    top: 0.3em;
  }
  
  #containt .grid-height {
    height: 570px;
  }
  
  ::v-deep .el-dialog {
    // height: 700px;
    overflow: hidden;
  }
  
  ::v-deep body .dialog-style {
    border-radius: 8px;
    -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
    // height: 700px;
    overflow: hidden;
  }
  
  /* 注意此处不能有scoped 否则样式无法生效 */
  .el-cascader-panel {
    .el-radio__inner {
      border: 0px;
      background: transparent;
    }
  
    .el-radio__input.is-checked .el-radio__inner {
      background: none;
    }
  
    .el-radio {
      height: 100%;
      width: 150px;
      position: absolute;
      z-index: 10;
    }
  }
  
  .table_main {
    padding-top: 5px;
    padding-left: 5px;
    border: 1px solid #ededed;
    width: calc(100% - 215px);
    border-bottom: none;
  
    .el-pagination {
      padding: 2px;
  
    }
  }
  
  .left_tree {
    width: 205px;
  
    .title {
      text-align: left;
      width: 182px;
      padding: 7px 0 5px !important;
      font-size: 13px;
      color: rgba(58, 39, 39, 0.96);
  
      > span {
        position: relative;
        left: 4px;
        top: -3px;
      }
    }
  
    ::v-deep.el-tree-node__label {
      width: calc(100% - 32px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
    }
  }
  
  .tree_icon {
    background: #f0f3ff;
  }
  
  // 重新修改tree组件样式
  ::v-deep.tree-line {
    .el-tree-node {
      position: relative;
      padding-left: 0px;
    }
  
    .el-tree-node__content {
      margin-top: 0px;
    }
  
    .el-tree-node__children {
      padding-left: 16px;
    }
  
    .el-tree-node::before {
      content: '';
      height: 100%;
      width: 1px;
      position: absolute;
      left: -3px;
      top: -26px;
      border-width: 1px;
      border-left: 1px dashed #d9d9d9;
    }
  
    .el-tree-node:last-child::before {
      height: 38px;
    }
  
    .el-tree-node::after {
      content: '';
      width: 24px;
      height: 1px;
      position: absolute;
      left: -3px;
      top: 12px;
      border-width: 1px;
      border-top: 1px dashed #d9d9d9;
    }
  
    & > .el-tree-node::after {
      border-top: none;
    }
  
    & > .el-tree-node::before {
      border-left: none;
    }
  
    .el-tree-node__expand-icon {
      font-size: 17px;
  
      // color: #000;
      &.is-leaf {
        color: transparent;
        // display: none;
      }
    }
  }
  
  .btn_zdy {
    margin: 10px;
    border: 1px solid #dcdfe6 !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
    font-weight: 400;
    text-align: center;
    background-color: #FBFBFB !important;
  }
  
  .btn_zdy:hover {
    color: #2A6494 !important;
    border: 1px solid #2A6494 !important;
  }
  
  .btn_zdy2 {
    // 选取文件合同按钮
    // margin: 10px 60px;
    // margin-top: 6px;
    border: 1px solid #dcdfe6 !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
    font-weight: 400;
    text-align: center;
    background-color: #FBFBFB !important;
  }
  
  .btn_zdy2:hover {
    color: #2A6494 !important;
    border: 1px solid #2A6494 !important;
  }
  
  ::v-deep.table-detail .el-upload--picture-card {
    // margin-top: 10px;
    width: 40px;
    height: 40px;
    line-height: 50px !important;
  }
  
  ::v-deep .el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 40px;
    height: 40px;
    margin-right: 14px;
    border-radius: 2px;
    padding: 0 !important;
    border-color: #e8e8e8;
    margin-top: 0;
    margin-bottom: 10px;
  }
  
  ::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
    width: 40px;
    height: 40px;
    padding: 0 !important;
    position: inherit;
    cursor: pointer;
  }
  .vxe-grid .vxe-grid--pager-wrapper {
      display: block;
      width: 100%;
      position: fixed;
      bottom: -38px !important;
      position: absolute !important;
      z-index: 9999999;
      background-color: #ffffff;
  }
  
  </style>
  